module.exports = __webpack_public_path__ + "img/collection-weddingRingsSlim@2x.0d3259c.webp";